// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__nS7rY","label":"Completed_label__1Qflv"};